import ReactOnRails from 'react-on-rails';

import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

import AnalyticsDashboard from '../components/AnalyticsDashboard'
import BatchUpdateV2 from '../components/BatchUpdateV2'
import BrowseDropdown from '../components/BrowseDropdown'
import CancellationFlow from '../components/CancellationFlow'
import CollapsibleGenreBrowser from '../components/CollapsibleGenreBrowser'
import Collections from '../components/Collections'
import CommentWidget from '../components/CommentWidget'
import ComplementarySamples from '../components/ComplementarySamples'
import DuplicateErrorMessage from '../components/DuplicateErrorMessage'
import ReportButton from '../components/ReportButton'
import BottomDrawer from '../components/BottomDrawer'
import NotificationsDropdown from '../components/NotificationsDropdown'
import NotificationsFeed from '../components/NotificationsFeed'
import PricingTable from '../components/PricingTable'
import ProfileNavTabs from '../components/ProfileNavTabs'
import SaleCountdown from '../components/SaleCountdown'
import Carousel from '../components/Carousel'
import SamplesAndCollections from '../components/SamplesAndCollections'
import SamplesStoreWrapper from '../components/SamplesStoreWrapper'
import SampleReviewFilter from '../components/SampleReviewFilter'
import SampleWaveform from '../components/SampleWaveform'
import SampleWaveformContainer from '../components/SampleWaveformContainer'
import SequenceWaveformContainer from '../components/SequenceWaveformContainer'
import SamplesWithTagFilter from '../components/SamplesWithTagFilter'
import Sequences from '../components/Sequences'
import SignUpOfferDialog from '../components/SignUpOfferDialog'
import UserSummaryCard from '../components/UserSummaryCard'
import VolumeControl from '../components/VolumeControl'

// Create Emotion cache with the same key as on the server
const cache = createCache({ key: 'css', prepend: true });

// Wrap each component with CacheProvider for Emotion
const withEmotionClient = (Component) => (props) => (
  <CacheProvider value={cache}>
    <Component {...props} />
  </CacheProvider>
);

// Register components with ReactOnRails and wrap with Emotion CacheProvider
ReactOnRails.register({
  AnalyticsDashboard: withEmotionClient(AnalyticsDashboard),
  BatchUpdateV2: withEmotionClient(BatchUpdateV2),
  BrowseDropdown: withEmotionClient(BrowseDropdown),
  CancellationFlow: withEmotionClient(CancellationFlow),
  CollapsibleGenreBrowser: withEmotionClient(CollapsibleGenreBrowser),
  Collections: withEmotionClient(Collections),
  CommentWidget: withEmotionClient(CommentWidget),
  ComplementarySamples: withEmotionClient(ComplementarySamples),
  DuplicateErrorMessage: withEmotionClient(DuplicateErrorMessage),
  BottomDrawer: withEmotionClient(BottomDrawer),
  NotificationsDropdown: withEmotionClient(NotificationsDropdown),
  NotificationsFeed: withEmotionClient(NotificationsFeed),
  ProfileNavTabs: withEmotionClient(ProfileNavTabs),
  PricingTable: withEmotionClient(PricingTable),
  SaleCountdown: withEmotionClient(SaleCountdown),
  SamplesAndCollections: withEmotionClient(SamplesAndCollections),
  Carousel: withEmotionClient(Carousel),
  ReportButton: withEmotionClient(ReportButton),
  SamplesStoreWrapper: withEmotionClient(SamplesStoreWrapper),
  SampleReviewFilter: withEmotionClient(SampleReviewFilter),
  SampleWaveform: withEmotionClient(SampleWaveform),
  SampleWaveformContainer: withEmotionClient(SampleWaveformContainer),
  SequenceWaveformContainer: withEmotionClient(SequenceWaveformContainer),
  SamplesWithTagFilter: withEmotionClient(SamplesWithTagFilter),
  Sequences: withEmotionClient(Sequences),
  SignUpOfferDialog: withEmotionClient(SignUpOfferDialog),
  UserSummaryCard: withEmotionClient(UserSummaryCard),
  VolumeControl: withEmotionClient(VolumeControl),
});
